import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScale = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1,.cls-2,.cls-3{fill:none;stroke:currentColor;}.cls-1,.cls-3{stroke-miterlimit:10;}.cls-1,.cls-2{stroke-width:1.5px;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-3{stroke-width:3px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M3.84,3H20a1,1,0,0,1,1,1V19a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V3.84A.84.84,0,0,1,3.84,3Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-2",
			cx: 12,
			cy: 8,
			r: 5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-3",
			x1: 12,
			y1: 6,
			x2: 12,
			y2: 10
		})
	]
});
export default SvgScale;
